import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import MapMarkerIcon from '../../assets/images/mapMarker.png';
import Actionbar from "../Common/Actionbar";
import API from "../../services/API";
import {toast} from "react-toastify"; // استفاده از آیکون محلی
import { useParams } from 'react-router-dom';
// کامپوننت داخلی برای مدیریت رویدادهای نقشه
function MapEventsHandler({ onPositionChange }) {
    const map = useMapEvents({
        moveend: () => {
            onPositionChange(map.getCenter());
        },
    });
    return null;
}

const LocationPicker = () => {
    const defaultPosition = {
        lat: parseFloat(window.localStorage.getItem("latE")) || 35.6892,
        lng: parseFloat(window.localStorage.getItem("lngE")) || 51.3890
    };

    const { id } = useParams();

    const [position, setPosition] = useState(defaultPosition);
    const [address, setAddress] = useState(window.localStorage.getItem("addressE"));
    const [statusMessage, setStatusMessage] = useState('در حال دریافت موقعیت مکانی شما...');

    // --- تابع اصلاح‌شده با استفاده از ipinfo.io ---
    const fetchLocationByIp = () => {
        setStatusMessage('مکان‌یابی دقیق ناموفق بود. در حال دریافت موقعیت تقریبی...');

        // !!! مهم: توکن رایگان خود را که از سایت ipinfo.io گرفته‌اید، اینجا قرار دهید
        const IPINFO_TOKEN = '393c6d90099108';

        // درخواست به سرویس ipinfo.io از طریق HTTPS
        fetch(`https://ipinfo.io/json?token=${IPINFO_TOKEN}`)
            .then(response => {
                if (!response.ok) throw new Error('پاسخ از سرویس ipinfo.io صحیح نبود.');
                return response.json();
            })
            .then(data => {
                // ساختار پاسخ در ipinfo متفاوت است. موقعیت در فیلد 'loc' به صورت "lat,lng" قرار دارد
                if (data.loc) {
                    const [latitude, longitude] = data.loc.split(',');
                    setPosition({ lat: parseFloat(latitude), lng: parseFloat(longitude) });
                    setStatusMessage('موقعیت تقریبی شما یافت شد. برای دقت بیشتر، نقشه را جابجا کنید.');
                } else {
                    throw new Error(data.error?.message || 'اطلاعات موقعیت از سرویس دریافت نشد.');
                }
            })
            .catch((error) => {
                console.error("Fetch by IP error:", error.message);
                setPosition(defaultPosition);
                setStatusMessage('سرویس مکان‌یابی در دسترس نیست. از موقعیت پیش‌فرض استفاده شد.');
            });
    };

    // دریافت موقعیت مکانی اولیه (بدون تغییر)
    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
            (pos) => {
                const { latitude, longitude } = pos.coords;
                setPosition({ lat: latitude, lng: longitude });
                setStatusMessage('موقعیت دقیق شما با موفقیت یافت شد.');
            },
            (err) => {
                console.error(`Geolocation Error: ${err.message}`);
                fetchLocationByIp(); // فراخوانی تابع جدید
            },
            { enableHighAccuracy: true, timeout: 8000 }
        );
    }, []);

    const handleSaveLocation = () => {
        const request = {
            id,
            d_lat: position.lat,
            d_lng: position.lng,
            address: address,
        };
        API.saveAddress(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    window.history.back()
                },1500)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    };

    return (
        <div style={{  textAlign: 'center' }} className='mt-5 pt-2'>
            <Actionbar noBack={0} title='اصلاح آدرس  '/>
            <h2>موقعیت را با جابجایی نقشه انتخاب کنید</h2>
            <p style={{ color: '#555', fontStyle: 'italic' }}>{statusMessage}</p>

            <div style={{ position: 'relative', height: '400px', width: '100%' }}>
                <MapContainer
                    center={position}
                    zoom={14}
                    style={{ height: '100%', width: '100%' }}
                    key={`${position.lat}-${position.lng}`}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.idmt.ir">توسعه هوشمند</a> '
                    />
                    <MapEventsHandler onPositionChange={setPosition} />
                </MapContainer>

                <div style={{
                    position: 'absolute', top: '50%', left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 401,
                    pointerEvents: 'none',
                }}>
                    <img
                        src={MapMarkerIcon}
                        alt="Marker"
                        style={{ width: '16px', height: '16px' }}
                    />
                </div>
            </div>

{/*            <div style={{ marginTop: '20px' }}>
                <p><strong>عرض جغرافیایی:</strong> {position.lat.toFixed(6)}</p>
                <p><strong>طول جغرافیایی:</strong> {position.lng.toFixed(6)}</p>
            </div>*/}

            <div className='rtl' style={{ marginTop: '20px' }}>
                <textarea

                    placeholder="آدرس دقیق را وارد کنید"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    style={{ width: '80%', padding: '10px', fontSize: '1rem' }}
                />
            </div>

            <button
                onClick={handleSaveLocation}
              className='btn btn-success w-100'
            >
                ذخیره آدرس و موقعیت
            </button>
        </div>
    );
};

export default LocationPicker;
